import { getIn, useFormikContext } from "formik";
import { useEffect } from "react";
import AutocompleteAsyncFormik from "../../../../../common/components/form/AutocompleteAsyncFormik";
import { createDebounce } from "../../../../../common/helpers/debounce.helper";
import { Period, getPeriods } from "../../../../../common/services/plans.api";

const getPeriodDebounced = createDebounce(getPeriods, 100)

interface AvailablePeriodsFieldFormikProps {
  onChange?: (selectedPeriod: string) => void;
}

export function AvailablePeriodsFieldFormik({ onChange }: AvailablePeriodsFieldFormikProps) {
  const formik = useFormikContext();
  const contractType = getIn(formik.values, 'contractType');
  const selectedPeriod = getIn(formik.values, "period");

  useEffect(() => {
    onChange?.(selectedPeriod?.label || "");
  }, [onChange, selectedPeriod]);

  const loadOptions = async () => {
    const result = await getPeriodDebounced({
    }) as { ok: boolean, data: Period[] }

    const availablePlansMotoClub = /moto/.test(contractType) ? result.data.filter((item) => item.label.includes('Moto')) : result.data;
    if (!result.ok) {
      return []
    }

    const options = (availablePlansMotoClub).map((item) => Object.assign(item, { label: `${item.label}` }))

    return options
  }

  return (
    <AutocompleteAsyncFormik
      label="Período"
      name="period"
      valueProperty="label"
      loadOptions={loadOptions}
    />
  )
}
